export default "__VITE_ASSET__C7A5liAA__"